import { MirrorService } from 'services/MirrorService';

import {
  getLocalStorageItem,
  removeLocalStorageItem,
  setLocalStorageItem,
} from 'helpers/localStorage';
import {
  getSessionStorageItem,
  removeSessionStorageItem,
  setSessionStorageItem,
} from 'helpers/sessionStorage';

import {
  PWA_CUSTOM_PROMOTION_SHOW_STORAGE_KEY,
  PWA_INSTALL_BUTTON_TEXT_DEFAULT,
  PWA_INSTALL_BUTTON_TEXT_SITE_GROUP_1,
  PWA_INSTALL_BUTTON_TEXT_SITE_GROUP_2,
  PWA_INSTALLED_STORAGE_KEY,
  PWA_SW_PATH,
  PWA_TRACKING_COOKIES_STORAGE_KEY,
} from './constants';

export const isPWAMode = () => {
  return window.matchMedia('(display-mode: standalone)').matches;
};

export const getIsPWAInstalled = () => {
  return Boolean(getLocalStorageItem(PWA_INSTALLED_STORAGE_KEY));
};
export const setIsPWAInstalled = (value: boolean) => {
  return setLocalStorageItem(PWA_INSTALLED_STORAGE_KEY, String(value));
};
export const removeIsPWAInstalled = () => {
  return removeLocalStorageItem(PWA_INSTALLED_STORAGE_KEY);
};

export const getIsPWAPromotionDisabled = () => {
  return Boolean(getSessionStorageItem(PWA_CUSTOM_PROMOTION_SHOW_STORAGE_KEY));
};
export const setIsPWAPromotionDisabled = (value: boolean) => {
  return setSessionStorageItem(
    PWA_CUSTOM_PROMOTION_SHOW_STORAGE_KEY,
    String(value)
  );
};
export const removeIsPWAPromotionDisabled = () => {
  return removeSessionStorageItem(PWA_CUSTOM_PROMOTION_SHOW_STORAGE_KEY);
};

export const getPWATrackingCookies = () => {
  return getLocalStorageItem(PWA_TRACKING_COOKIES_STORAGE_KEY);
};
export const setPWATrackingCookies = (cookies: string) => {
  setLocalStorageItem(PWA_TRACKING_COOKIES_STORAGE_KEY, cookies);
};
export const removePWATrackingCookies = () => {
  return removeLocalStorageItem(PWA_TRACKING_COOKIES_STORAGE_KEY);
};

export const registerPWAServiceWorker = async () => {
  if (!('serviceWorker' in navigator)) return;

  try {
    await navigator.serviceWorker.register(PWA_SW_PATH);
  } catch (err) {
    console.error('registerPwaServiceWorker: ', err);
  }
};

export const getPWAInstallButtonText = () => {
  if (MirrorService.groupId === 1) {
    return PWA_INSTALL_BUTTON_TEXT_SITE_GROUP_1;
  }
  if (MirrorService.groupId === 2) {
    return PWA_INSTALL_BUTTON_TEXT_SITE_GROUP_2;
  }

  return PWA_INSTALL_BUTTON_TEXT_DEFAULT;
};
